import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { getRankHoverBorderClass } from "@/components/waves/drops/dropRankStyles";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import React from "react";
import { createPortal } from "react-dom";
import { WaveWinnersDropHeader } from "./header/WaveWinnersDropHeader";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
import WaveWinnersDropHeaderTotalVotes from "./header/WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./header/WaveWinnersDropHeaderVoters";
import WaveWinnersDropOutcome from "./header/WaveWinnersDropOutcome";
import { WaveWinnersDropContent } from "./WaveWinnersDropContent";
import { WaveWinnerIdentity } from "../identity/WaveWinnerIdentity";
interface DefaultWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
const getRankHoverClass = (place: number | null): string => {
  return getRankHoverBorderClass(place);
};
export const DefaultWaveWinnersDrop: React.FC<DefaultWaveWinnersDropProps> = t0 => {
  const $ = _c(49);
  const {
    winner,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== winner.drop) {
    t2 = convertApiDropToExtendedDrop(winner.drop);
    $[2] = winner.drop;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const extendedDrop = t2;
  const userContextRating = winner.drop.context_profile_context?.rating ?? 0;
  const hasUserVoted = userContextRating !== 0;
  const userVote = userContextRating;
  const isUserVoteNegative = userVote < 0;
  const creditType = WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type] || "votes";
  let t3;
  if ($[4] !== extendedDrop || $[5] !== onDropClick) {
    t3 = () => onDropClick(extendedDrop);
    $[4] = extendedDrop;
    $[5] = onDropClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== winner.place) {
    t4 = getRankHoverClass(winner.place);
    $[7] = winner.place;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `tw-group tw-cursor-pointer tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 ${t4}`;
  let t6;
  if ($[9] !== winner) {
    t6 = <WaveWinnersDropHeaderAuthorPfp winner={winner} />;
    $[9] = winner;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== winner) {
    t7 = <div className="tw-flex tw-w-full tw-flex-col tw-gap-y-2"><WaveWinnersDropHeader winner={winner} showVotingInfo={false} /><WaveWinnersDropContent winner={winner} isCompetitionDrop={true} /></div>;
    $[11] = winner;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="tw-flex tw-flex-1 tw-gap-x-3">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== extendedDrop || $[17] !== hasTouchScreen) {
    t9 = !hasTouchScreen && <div className="tw-flex tw-flex-shrink-0 tw-items-start"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
    $[16] = extendedDrop;
    $[17] = hasTouchScreen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="tw-relative tw-z-10 tw-flex tw-w-full tw-justify-between tw-gap-x-3 tw-border-0 tw-bg-transparent tw-text-left">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== winner.drop) {
    t11 = <WaveWinnerIdentity drop={winner.drop} variant="full" cardVariant="chat" />;
    $[22] = winner.drop;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== winner) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 tw-pt-2"><div className="tw-flex tw-items-center tw-gap-x-4 tw-whitespace-nowrap"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div><div><WaveWinnersDropOutcome winner={winner} /></div></div>;
    $[24] = winner;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== creditType || $[27] !== hasUserVoted || $[28] !== isUserVoteNegative || $[29] !== userVote) {
    t13 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-font-normal tw-text-iron-400">{creditType}</span></span></div></div>;
    $[26] = creditType;
    $[27] = hasUserVoted;
    $[28] = isUserVoteNegative;
    $[29] = userVote;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t13) {
    t14 = <div className="tw-ml-[3.25rem]"><div className="tw-flex tw-flex-col tw-gap-y-2">{t11}{t12}{t13}</div></div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t10 || $[36] !== t14 || $[37] !== touchHandlers) {
    t15 = <div className="tw-rounded-xl tw-p-4" {...touchHandlers}>{t10}{t14}</div>;
    $[35] = t10;
    $[36] = t14;
    $[37] = touchHandlers;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== extendedDrop || $[40] !== hasTouchScreen || $[41] !== isActive || $[42] !== setIsActive) {
    t16 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[39] = extendedDrop;
    $[40] = hasTouchScreen;
    $[41] = isActive;
    $[42] = setIsActive;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t15 || $[45] !== t16 || $[46] !== t3 || $[47] !== t5) {
    t17 = <div onClick={t3} className={t5}>{t15}{t16}</div>;
    $[44] = t15;
    $[45] = t16;
    $[46] = t3;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
};